export const currentMenus = (state) => (site) => {
  const now = new Date();

  return state.menus
    .filter((x) => x.validFrom.toDate() <= now)
    .filter((x) => x.validTo.toDate() >= now);
};
